/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { paymentMethodSetupIntent } from '../../axios/paymentMethodSetupIntent'
import type {
	PaymentMethodSetupIntentError,
	PaymentMethodSetupIntentPathParams,
	PaymentMethodSetupIntentRequest,
	PaymentMethodSetupIntentResponse,
} from '../../types/PaymentMethodSetupIntent'

export const paymentMethodSetupIntentMutationKey = () =>
	[{ url: '/:organisation/payment-methods/setup-intent' }] as const

export type PaymentMethodSetupIntentMutationKey = ReturnType<typeof paymentMethodSetupIntentMutationKey>

export type PaymentMethodSetupIntentVariables = {
	organisation: PaymentMethodSetupIntentPathParams['organisation']
	data: PaymentMethodSetupIntentRequest
}

/** @see backend/nexus/modules/Billing/Http/Controllers/PaymentMethodController.php PaymentMethodController::setupIntent */
export function usePaymentMethodSetupIntent<TContext = unknown>(
	options?: UseMutationOptions<
		PaymentMethodSetupIntentResponse,
		AxiosError<PaymentMethodSetupIntentError>,
		PaymentMethodSetupIntentVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: paymentMethodSetupIntentMutationKey(),
		mutationFn: ({ organisation, data }: PaymentMethodSetupIntentVariables) =>
			paymentMethodSetupIntent(organisation, data, config).then(res => res.data),
		...options,
	})
}
